import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtEur, fmtDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PAG_CAT } from "@/components/PagamentoDialog";
import { padrLabel } from "@/components/PadroncinoSelect";
import { stato, daysUntil } from "@/pages/Scadenzario";
import { Wallet, ArrowRight } from "lucide-react";

export const PagamentiRiepilogo = ({ company }) => {
  const [items, setItems] = useState([]);
  const [padroncini, setPadroncini] = useState([]);
  useEffect(() => {
    api.get("/padroncini", { params: { company } }).then((r) => setPadroncini(r.data));
    api.get("/pagamenti", { params: { company } }).then((r) =>
      setItems(r.data.filter((p) => p.stato === "da_pagare" && daysUntil(p.data_scadenza) <= 15)));
  }, [company]);
  const scaduti = items.filter((p) => daysUntil(p.data_scadenza) < 0);
  const tot = items.reduce((a, p) => a + p.importo, 0);
  return (
    <Card className="p-4 rounded-md" data-testid="dash-pagamenti">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <div className="font-heading font-bold flex items-center gap-2"><Wallet className="w-4 h-4" />Pagamenti da fare entro 15 giorni
          <span className="font-mono text-sm font-normal text-muted-foreground" data-testid="dash-pag-totale">{fmtEur(tot)}</span>
          {scaduti.length > 0 && <Badge className="bg-red-600 text-white h-5" data-testid="dash-pag-scaduti">{scaduti.length} scaduti</Badge>}
        </div>
        <Button asChild size="sm" variant="ghost" className="h-7 text-xs gap-1" data-testid="dash-pag-vai">
          <Link to="/pagamenti">Pagamenti<ArrowRight className="w-3.5 h-3.5" /></Link>
        </Button>
      </div>
      {items.length === 0 ? <div className="text-sm text-muted-foreground py-4 text-center">Nessun pagamento in scadenza</div> : (
        <ul className="divide-y divide-border">
          {items.slice(0, 8).map((p) => {
            const s = stato(p.data_scadenza);
            return (
              <li key={p.id} className="py-1.5 flex items-center gap-3 text-sm" data-testid={`dash-pag-${p.id}`}>
                <span className="font-mono text-xs w-20">{fmtDate(p.data_scadenza)}</span>
                <Badge variant="outline" className="h-5">{PAG_CAT.find((c) => c.value === p.categoria)?.label}</Badge>
                <span className="flex-1 truncate">{(p.categoria === "padroncini" && padrLabel(padroncini.find((x) => x.id === p.padroncino_id))) || p.beneficiario || p.descrizione}{p.rate_tot > 1 && <span className="text-xs text-muted-foreground"> ({p.rata_n}/{p.rate_tot})</span>}</span>
                <span className="font-mono">{fmtEur(p.importo)}</span>
                <Badge className={`${s.cls} text-white h-5 whitespace-nowrap`}>{s.txt}</Badge>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
};
